
/* 楼盘字典-街道 */
<template>
  <div class="body_wapper">

    <div class="warpper_page">
      <div class="warpper_top disFlex" style="justify-content: space-between">
        <h2 class="warpper_top_title">街道</h2>
        <a-button-group>
          <a-button type="primary" title="更多" @click="showOpt = !showOpt">
            <a-icon type="edit" />
          </a-button>
          <a-button type="primary" title="新增街道" @click="goPage('add', '')">
            <a-icon type="plus" />
          </a-button>
        </a-button-group>
      </div>
      <div class="wrapper_search">
        <a-input-search prefix="" placeholder="街道名称" style="width: 200px" @search="searchHandle" />
      </div>
      <div class="disFlex flexWrap list_district">
        <dl
          class="item_record"
          :class="{ cur: index === curIdx }"
          v-for="(item, index) in sList"
          :key="item.id"
          @click="selRow(index, item.id)"
        >
          <h3 class="item_dis_title" :title="item.streetFullName">{{ item.streetFullName }}</h3>
          <div class="item_dis_opts" v-if="showOpt">
            <!-- <a-button type="link" :class="{ btn_opt: btnOptShow }" @click.stop="delHandle(item)">
              <a-icon
                type="delete"
                v-if="index === curIdx"
                theme="filled"
                class="borderradius50b"
                :style="btnStyleSel"
              />
              <a-icon type="delete" v-else theme="filled" class="borderradius50b" :style="btnStyle" />
            </a-button> -->
            <a-button type="link" :class="{ btn_opt: btnOptShow }" @click.stop="goPage('edit', item.id)">
              <a-icon
                type="edit"
                v-if="index === curIdx"
                theme="filled"
                class="borderradius50b"
                :style="btnStyleSel"
              />
              <a-icon type="edit" v-else theme="filled" class="borderradius50b" :style="btnStyle" />
            </a-button>
          </div>
          <div class="item_dis_opts" v-else>
            <a-button type="link" :class="{ btn_opt: btnOptShow }" @click.stop="goPage('detail', item.id)">
              <a-icon
                type="small-dash"
                v-if="index === curIdx"
                theme="filled"
                class="borderradius50b"
                :style="btnStyleSel"
              />
              <a-icon type="small-dash" v-else theme="filled" class="borderradius50b" :style="btnStyle" />
            </a-button>
          </div>
        </dl>
      </div>
    </div>

  </div>
</template>

<script>
import {
  // streetList, getStreet, addStreet, updateStreet,
 delStreet } from '@/api/setting/street'
import storage from 'store'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'Street',
  components: {},
  props:
  //  ['streetList', 'businessDisList', 'businessDistrictId'],
  {
    streetList: {
        type: Array,
        default: () => []
    },
    businessDisList: {
        type: Array,
        default: () => []
    },
    // eslint-disable-next-line vue/require-default-prop
    businessDistrictId: {
        type: Number
    }
  },

  mixins: [tableMixin],
  data () {
    return {
      sList: [],
      curIdx: -1,
      showOpt: false,
      loading: false,
      submitLoading: false,

      btnOptShow: false,
      btnStyle: { fontSize: '14px', color: 'var(--ThemeColor)' },
      btnStyleSel: { fontSize: '14px', color: '#ffffff' },

      visible: false,
      confirmLoading: false,
      formTitle: '操作',

      queryParam: {
        businessDistrictId: this.businessDistrictId, //	商圈ID
        streetFullName: undefined, //	街道全称
        streetShortName: undefined //	街道简称
      },

      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      dataInfo: {
        businessDistrictName: undefined, //	街道名称(必填)
        businessDistrictScope: undefined, //	街道范围(选填)
        districId: undefined, //	区域ID	(必填)
        id: undefined, //	id(新增时不传，修改时必传)
        isPrimaryBusinessDistrict: undefined //	是否主街道	(必填)	字典表类型：sys_yes_no
      },
      rules: {
        businessDistrictName: [{ required: true, message: '必填', trigger: 'blur' }],
        districId: [{ required: true, message: '必填', trigger: 'blur' }],
        isPrimaryBusinessDistrict: [{ required: true, message: '必填', trigger: 'blur' }]
      },
      headers: {
        Authorization: 'Bearer ' + storage.get(ACCESS_TOKEN),
        Accept: 'application/json, text/plain, */*' // multipart/form-data
      },
      columns: []
    }
  },
  filters: {},
  created () {},
  computed: {},
  watch: {
    streetList (val) {
      // console.log(val)
      this.sList = val
      // if (this.sList && this.sList.length > 0) {
      //     this.selRow(0, this.sList[0].id)
      // }
    }
  },
  methods: {
    goPage (pageType, id) {
      this.$router.push({ path: '/street/' + pageType, query: { dataId: id } })
    },

    delHandle (row) {
      const that = this
      const streetId = row.id
      const name = row.streetShortName

      that.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中【' + name + '】的数据',
        onOk () {
          return delStreet(streetId).then(() => {
            that.searchHandle('')
            that.$message.success('删除成功', 3)
          })
        },
        onCancel () {}
      })
    },

    searchHandle (value) {
      this.queryParam.streetFullName = value // 街道全称
      this.queryParam.streetShortName = value // 街道简称
      // this.queryParam.businessDistrictId = this.businessDistrictId // 商圈ID
      this.queryParam.businessDistrictId = undefined

      this.$emit('queryStreetEvent', this.queryParam)
    },

    selRow (idx, id) {
      this.curIdx = idx
      this.$emit('streetIdEvent', id)
    },
    initParam () {
      this.queryParam = {
        streetFullName: undefined, // 街道全称
        streetShortName: undefined, // 街道简称
        businessDistrictId: this.businessDistrictId // 商圈ID
      }
    }
  }
}
</script>

<style scoped>
.warpper_top{
  margin:0 10px;
}
.wrapper_search{
   margin:0 10px;
}
.borderradius50b {
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  -ms-border-radius: 50%;
}
.list_district {
  flex-direction: column;
  margin-top: 20px;
}

.btn_opt {
  margin-right: 5px;
}
.item_dis_title {
  margin: 0px;
}
.cur .item_dis_title {
  color: #fff;
  font-weight: bold;
}
.item_dis_opts {
  display: flex;
}
.item_record {
  height: 40px;
  display: block;
  line-height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 96%;
  padding: 0px 2%;
  cursor: pointer;
  font-size: 14px;
}
</style>
